exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm-btn-area {\n  height: 88px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n}\n.confirm-btn-area .btn1 {\n  margin-left: auto;\n  min-width: 64px;\n  height: 32px;\n}\n.confirm-btn-area .btn2 {\n  margin-right: 24px;\n  margin-left: 24px;\n  min-width: 64px;\n  height: 32px;\n}\n", ""]);

// exports
